// websocket.js - Vuex Store Modul für WebSocket-Funktionalitäten
export default {
  namespaced: true,

  state: () => ({
    messages: []
  }),

  mutations: {
    ADD_MESSAGE(state, message) {
      state.messages = [...state.messages, message].sort((a, b) => a.createdAt - b.createdAt)
    },

    ADD_MESSAGES(state, messages) {
      state.messages = messages
    },

    REMOVE_COMMENT_NOTIFICATION(state, id) {
      state.messages = state.messages.filter((msg) => msg.comment._id !== id)
    },

    REMOVE_COMMENT_NOTIFICATIONS(state, commentIds) {
      state.messages = state.messages.filter((message) =>
        !message.comment || !commentIds.includes(message.comment._id))
    },

    CLEAR_MESSAGES(state) {
      state.messages = []
    }
  },

  actions: {
    addMessage({ commit }, message) {
      commit('ADD_MESSAGE', message.notification)
    },

    clearMessages({ commit }) {
      commit('CLEAR_MESSAGES')
    },

    removeCommentNotification({ commit }, id) {
      commit('REMOVE_COMMENT_NOTIFICATION', id)
    },

    removeCommentNotifications({ commit }, commentIds) {
      commit('REMOVE_COMMENT_NOTIFICATIONS', commentIds)
    },

    initNotifications({ commit }, message) {
      if (!message.notifications || !message.notifications.length) {
        return
      }
      commit('ADD_MESSAGES', message.notifications)
    }
  },

  getters: {
    messages: state => state.messages
  }
}
